import { useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Textarea } from '@/new/components/shadcn/textarea';

export function AskKim({ allDocumentsSubsetId }: { allDocumentsSubsetId: string }) {
  const { matterId } = useParams();
  if (!matterId) return null;

  const navigate = useNavigate();
  const [kimQuestion, setKimQuestion] = useState('');

  const handleAskKim = () => {
    if (!kimQuestion.trim()) return;
    navigate(`/matters/${matterId}/subsets/${allDocumentsSubsetId}/kim`, {
      state: { question: kimQuestion.trim() },
    });
  };

  return (
    <div className="mb-6 rounded-md border border-gray-200 bg-white p-4">
      <div className="mb-2 flex items-center gap-2">
        <Icon className="lucide--message-circle-question text-base text-gray-500" />
        <h2 className="font-serif text-lg font-semibold text-gray-900">Ask Kim</h2>
      </div>
      <p className="mb-3 text-sm text-gray-600">Ask a question over all documents in this matter.</p>
      <div className="space-y-2">
        <Textarea
          placeholder="What would you like to know?"
          value={kimQuestion}
          onChange={(e) => setKimQuestion(e.target.value)}
          rows={3}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleAskKim();
            }
          }}
        />
        <Button onClick={handleAskKim} disabled={!kimQuestion.trim()} className="w-full">
          <Icon className="lucide--send" />
          Ask question
        </Button>
      </div>
    </div>
  );
}
